import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import no from './locales/no.json';
import en from './locales/en.json';
import so from './locales/so.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json';
import es from './locales/es.json';

const resources = {
  no: { translation: no },
  en: { translation: en },
  so: { translation: so },
  ar: { translation: ar },
  fr: { translation: fr },
  es: { translation: es }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'no',
    supportedLngs: ['no', 'en', 'so', 'ar', 'fr', 'es'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',

    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
